var map = {
	"./template.bet575": 1894,
	"./template.bet575.tsx": 1894,
	"./template.bet777": 1895,
	"./template.bet777.tsx": 1895,
	"./template.betgalaxy": 1896,
	"./template.betgalaxy.tsx": 1896,
	"./template.betprofessor": 1897,
	"./template.betprofessor.tsx": 1897,
	"./template.betroyale": 2144,
	"./template.betroyale.tsx": 2144,
	"./template.betstride": 1898,
	"./template.betstride.tsx": 1898,
	"./template.buffalobet": 1899,
	"./template.buffalobet.tsx": 1899,
	"./template.chromabet": 1900,
	"./template.chromabet.tsx": 1900,
	"./template.default": 55,
	"./template.default.tsx": 55,
	"./template.epicodds": 1901,
	"./template.epicodds.tsx": 1901,
	"./template.fiestabet": 1902,
	"./template.fiestabet.tsx": 1902,
	"./template.forsport": 1903,
	"./template.forsport.tsx": 1903,
	"./template.gigabet": 1904,
	"./template.gigabet.tsx": 1904,
	"./template.goldenbet888": 1905,
	"./template.goldenbet888.tsx": 1905,
	"./template.goldenrush": 1906,
	"./template.goldenrush.tsx": 1906,
	"./template.hyperbet": 1907,
	"./template.hyperbet.tsx": 1907,
	"./template.juicybet": 1908,
	"./template.juicybet.tsx": 1908,
	"./template.junglebet": 1909,
	"./template.junglebet.tsx": 1909,
	"./template.magnumbet": 1910,
	"./template.magnumbet.tsx": 1910,
	"./template.oldgill": 1911,
	"./template.oldgill.tsx": 1911,
	"./template.puntcity": 1912,
	"./template.puntcity.tsx": 1912,
	"./template.puntgenie": 2029,
	"./template.puntgenie.tsx": 2029,
	"./template.pyramidbet": 1913,
	"./template.pyramidbet.tsx": 1913,
	"./template.questbet": 2145,
	"./template.questbet.tsx": 2145,
	"./template.slambet": 1914,
	"./template.slambet.tsx": 1914,
	"./template.sterlingparker": 2146,
	"./template.sterlingparker.tsx": 2146,
	"./template.sugarcastle": 1915,
	"./template.sugarcastle.tsx": 1915,
	"./template.templebet": 1916,
	"./template.templebet.tsx": 1916,
	"./template.titanbet": 1917,
	"./template.titanbet.tsx": 1917,
	"./template.ts": 997,
	"./template.vikingbet": 1918,
	"./template.vikingbet.tsx": 1918,
	"./template.volcanobet": 1919,
	"./template.volcanobet.tsx": 1919,
	"./template.wellbet": 1920,
	"./template.wellbet.tsx": 1920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2793;